import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  userInfo: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    changeAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    changeUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeAuthenticated, changeUserInfo } = userSlice.actions;

export default userSlice.reducer;
